import { cn } from '@talentmesh/ui/lib/utils';
import React from 'react';

export interface WideTabPanelProps {
    children: React.ReactNode;
    value: string;
    tabKey: string;
    className?: string;
}

function WideTabPanel({ tabKey, children, value, className }: WideTabPanelProps) {
    const isActive = tabKey === value;

    return (
        <div
            role="tabpanel"
            hidden={!isActive}
            data-state={isActive ? 'active' : 'inactive'}
            className={cn('flex-1 text-sm outline-none', className)}
        >
            {isActive ? children : null}
        </div>
    );
}
export default WideTabPanel;
